import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import styles from './Navigation.module.scss';
import { MobileNav } from './MobileNav';
import { Logo } from '../Branding/Logo';

export const TopNavigation: React.FC = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  return (
    <nav className={styles.navBar}>
      <Link to="/" style={{ textDecoration: 'none' }}>
        <Logo />
      </Link>
      
      <div className={styles.navLinks}>
        <Link to="/science-of-time">Science</Link>
        <Link to="/blog">Blog</Link>
        <Link to="/about">About Us</Link>
      </div>

      <div className={styles.authButtons}>
        <Link to="/login" className={styles.loginLink}>
          Log In
        </Link>
        <Link to="/register" className={styles.primaryButton} style={{ padding: '8px 24px', fontSize: '16px' }}>
          Sign Up Free
        </Link>
      </div>

      <MobileNav 
          isOpen={isMobileMenuOpen} 
          onToggle={() => setIsMobileMenuOpen(!isMobileMenuOpen)} 
          onClose={() => setIsMobileMenuOpen(false)}
      />
    </nav>
  );
};

